(() => {
  if (window.nordsignCategoryLayout) return;
  window.nordsignCategoryLayout = true;
  const roots = 'nordsign-flag-selector,nordsign-frame-selector,nordsign-range';
  let sequence = 0;
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    node.className = className;
    if (text) node.textContent = text;
    return node;
  };
  const icon = name => {
    const template = document.querySelector('[data-category-layout-icons]');
    const node = template?.content.querySelector(`[data-layout-icon="${name}"]`)?.cloneNode(true) || make('span', '');
    node.setAttribute('aria-hidden', 'true');
    return node;
  };
  function enhance(root, messages) {
    if (root.dataset.layoutReady || !root.querySelector('.ns-shared-card')) return;
    root.dataset.layoutReady = 'true';
    root.classList.add('ns-compact');
    const text = (key, values = {}) => (messages[key] || key).replace(/__(\w+)__/g, (token, name) => values[name] ?? token);
    const header = root.querySelector('.ns-shared-heading');
    const help = header?.querySelector(':scope > a');
    const guide = root.querySelector('.ns-flags__guide,.ns-frames__guide,.ns-range__guide');
    if (help && guide && typeof HTMLDialogElement !== 'undefined') {
      const dialog = make('dialog', 'ns-layout-guide');
      dialog.id = `CategoryGuidance-${++sequence}`;
      const title = make('h2', '', text('choose'));
      title.id = `${dialog.id}-title`;
      dialog.setAttribute('aria-labelledby', title.id);
      const close = make('button', 'ns-layout-icon');
      close.type = 'button';
      close.setAttribute('aria-label', text('close_guidance'));
      close.append(icon('close'));
      const heading = make('header', 'ns-layout-guide__heading');
      heading.append(title, close);
      const body = make('div', 'ns-layout-guide__body');
      [...guide.children].filter(child => child.tagName !== 'SUMMARY').forEach(child => body.append(child));
      const contact = help.cloneNode(true);
      contact.className = 'ns-layout-button ns-layout-button--primary';
      contact.replaceChildren(make('span', '', text('contact_expert')), icon('arrow'));
      body.append(contact);
      dialog.append(heading, body);
      const trigger = make('button', 'ns-layout-button ns-layout-help');
      trigger.type = 'button';
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-controls', dialog.id);
      trigger.append(make('span', '', text('choose')), icon('arrow'));
      help.replaceWith(trigger);
      guide.replaceWith(dialog);
      trigger.addEventListener('click', () => dialog.showModal());
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => trigger.focus({preventScroll:true}));
      dialog.addEventListener('click', event => {
        const box = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
      });
    }
    const filters = root.querySelector('.ns-flags__filters,.ns-frames__filters,.ns-range__tools:not(.ns-range__tools--small-range)');
    let filterButton;
    const syncFilters = () => {
      if (!filters) return;
      const active = [...filters.querySelectorAll('input,select')].filter(input => input.value.trim() !== '').length;
      const clear = filters.querySelector('[data-reset],[data-range-reset]');
      if (clear) clear.hidden = active === 0;
      filterButton.firstElementChild.textContent = text('filters') + (active ? ` (${active})` : '');
    };
    if (filters) {
      filters.classList.add('ns-layout-filters');
      filters.id ||= `CategoryFilters-${++sequence}`;
      filters.querySelectorAll('select').forEach(select => {
        const wrap = make('span', 'ns-layout-select');
        select.before(wrap);
        wrap.append(select, icon('caret'));
      });
      filterButton = make('button', 'ns-layout-button ns-layout-filter-toggle');
      filterButton.type = 'button';
      filterButton.setAttribute('aria-expanded', 'false');
      filterButton.setAttribute('aria-controls', filters.id);
      filterButton.append(make('span', '', text('filters')), icon('caret'));
      filters.before(filterButton);
      filterButton.addEventListener('click', () => {
        const open = filterButton.getAttribute('aria-expanded') !== 'true';
        filterButton.setAttribute('aria-expanded', String(open));
        filters.classList.toggle('is-open', open);
      });
      ['change','input','reset','click'].forEach(event => filters.addEventListener(event, () => requestAnimationFrame(syncFilters)));
      syncFilters();
    }
    const button = root.querySelector('.ns-flags__results [data-compare],.ns-frames__results [data-compare],.ns-range__results [data-range-compare]');
    if (!button) return;
    const comparison = root.querySelector('.ns-flags__dialog,.ns-frames__dialog,.ns-range__dialog');
    comparison?.classList.add('ns-layout-comparison');
    const region = comparison?.querySelector('.ns-flags__comparison,.ns-frames__table,.ns-range__table');
    if (region) {
      region.tabIndex = 0;
      region.setAttribute('role', 'region');
      region.setAttribute('aria-label', text('compare'));
    }
    const inputs = [...root.querySelectorAll('.ns-flag [data-select],[data-model] [data-select],[data-frame] [data-select],[data-range-card] input[data-compare]')];
    const tray = make('aside', 'ns-layout-compare');
    tray.setAttribute('aria-label', text('compare'));
    const inner = make('div', 'ns-layout-compare__inner');
    const status = make('div', 'ns-layout-compare__status');
    status.setAttribute('role', 'status');
    const count = make('strong', '');
    const hint = make('span', '');
    status.append(count, hint);
    const items = make('div', 'ns-layout-compare__items');
    const clear = make('button', 'ns-layout-clear', text('clear_selection'));
    clear.type = 'button';
    button.classList.add('ns-layout-button', 'ns-layout-button--primary');
    button.hidden = false;
    inner.append(status, items, clear, button);
    tray.append(inner);
    tray.hidden = true;
    root.append(tray);
    const setHeight = () => {
      const height = Math.max(0, ...[...document.querySelectorAll('.ns-layout-compare:not([hidden])')].map(node => node.getBoundingClientRect().height));
      document.documentElement.style.setProperty('--ns-compare-height', `${height}px`);
      document.body.classList.toggle('ns-has-compare', height > 0);
    };
    new ResizeObserver(setHeight).observe(tray);
    const selected = () => inputs.filter(input => input.checked);
    const update = () => {
      const choices = selected();
      tray.hidden = choices.length === 0;
      count.textContent = text('selected', {count:choices.length});
      hint.textContent = text(choices.length < 2 ? 'select_more' : 'compare_limit');
      button.replaceChildren(make('span', '', text('compare_action', {count:choices.length})), icon('arrow'));
      button.disabled = choices.length < 2 || choices.length > 5;
      inputs.forEach(input => { input.disabled = choices.length >= 5 && !input.checked; });
      comparison?.style.setProperty('--ns-compare-columns', String(choices.length + 1));
      items.replaceChildren(...choices.map(input => {
        const card = input.closest('[data-model],[data-frame],[data-range-card]');
        const title = card.dataset.productLabel || card.dataset.title || card.querySelector('h2,h3')?.textContent || input.getAttribute('aria-label');
        const item = make('div', 'ns-layout-compare__item');
        const image = card.querySelector('img')?.cloneNode();
        if (image) {image.alt = '';image.removeAttribute('loading');item.append(image);}
        item.append(make('span', '', title));
        const remove = make('button', 'ns-layout-icon');
        remove.type = 'button';
        remove.setAttribute('aria-label', text('remove_product', {product:title}));
        remove.append(icon('close'));
        remove.addEventListener('click', () => {
          input.checked = false;
          input.dispatchEvent(new Event('change', {bubbles:true}));
          update();
          if (!tray.hidden) clear.focus();
          else if (input.getClientRects().length) input.focus({preventScroll:true});
          else header?.querySelector('button,a')?.focus({preventScroll:true});
        });
        item.append(remove);
        return item;
      }));
      setHeight();
    };
    clear.addEventListener('click', () => {
      const first = selected().find(input => input.getClientRects().length);
      selected().forEach(input => {input.checked = false;input.dispatchEvent(new Event('change', {bubbles:true}));});
      update();
      (first || header?.querySelector('button,a'))?.focus({preventScroll:true});
    });
    let pending;
    const scheduleUpdate = () => {
      cancelAnimationFrame(pending);
      pending = requestAnimationFrame(() => { if (root.isConnected) update(); });
    };
    ['change','input','reset','click'].forEach(event => root.addEventListener(event, scheduleUpdate));
    // Browser-restored checkboxes do not dispatch input/change events.
    window.addEventListener('pageshow', scheduleUpdate);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') scheduleUpdate();
    });
    new MutationObserver(() => {if (comparison.open) setHeight();}).observe(comparison, {attributes:true,attributeFilter:['open']});
    update();
  }
  function init(scope = document) {
    const data = document.querySelector('[data-shared-category-messages]');
    if (!data) return;
    const messages = JSON.parse(data.textContent);
    const decoder = document.createElement('textarea');
    Object.keys(messages).forEach(key => {decoder.innerHTML = messages[key];messages[key] = decoder.value;});
    scope.querySelectorAll(roots).forEach(root => enhance(root, messages));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
